import matchCurrentSeason from "../chronology/current/match-current-season";
import getFutureSeason from "../chronology/future/get-future-season";
import getRecentSeason from "../chronology/recent/get-recent-season";

export default function findClosestSeason(parentVolume, store) {
  // Check if we have a season record for today.
  const currentSeason = matchCurrentSeason(parentVolume, store);

  // If the parent volume contains a season record for today,
  // then we want to use that one.
  if (currentSeason) {
    return currentSeason;
  }

  // As we do not have a day record for the given date, we now check
  // for future or past day records in the given season and school level.
  const futureSeason = getFutureSeason(parentVolume.seasons, store);
  if (futureSeason) {
    return futureSeason;
  }

  const recentSeason = getRecentSeason(parentVolume.seasons, store);
  if (recentSeason) {
    return recentSeason;
  }

  return null;
}
